import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nrw-junior',
  templateUrl: './nrw-junior.component.html',
  styleUrls: ['./nrw-junior.component.scss']
})
export class NRWJuniorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
